export const GAME_TITLES = {
  LAWBREAKERS:'LawBreakers',
  GEARS4:'Gears 4',
  CSGO:'CS:GO',
  TRICKSTRAT: '',
  SPORTS: 'Sports',
  RS6: 'Rainbow Six Siege',
  GEARS5:'GEARS 5',
  VALORANT: 'Valorant',
  ROGUECOMPANY: 'Rogue Company'
};

export const MAP_TITLES = {
  BLOODDRIVE:'Blood Drive',IMPACT:'Impact',DAM:'Dam',RECLAIMED:'Reclaimed',LIFT:'Lift',HARBOR:'Harbor',FOUNDATION:'Foundation',DINER:'Diner',FORGE:'Forge Blitz',THESLAB: 'The Slab',OLDTOWN:"Old Town",
  INFERNO: 'Inferno',TRAIN: 'Train',MIRAGE: 'Mirage',NUKE: 'Nuke',COBBLESTONE: 'Cobblestone',OVERPASS: 'Overpass',CACHE: 'Cache',
  PROMENADE: 'Promenade',REDFALLS: 'Redfalls',REACTOR: 'Reactor',STATION: 'Station',TRENCH: 'Trench',VERTIGO: 'Vertigo',GRANDVIEW:'Grandview',MAMMOTH:'Mammoth',
  SOCCER: 'Soccer',FOOTBALL: 'Football',BASKETBALL: 'Basketball',BASEBALL: 'Baseball',HOCKEY: 'Hockey',
  BANK1: 'Bank - Basement',BANK2: 'Bank - 1st Floor',BANK3: 'Bank - 2nd Floor',BANK4: 'Bank - Roof',CLUBHOUSE1: 'Clubhouse - Basement',CLUBHOUSE2: 'Clubhouse - 1st Floor', CLUBHOUSE3: 'Clubhouse - 2nd Floor', CLUBHOUSE4: 'Clubhouse - Roof',
  ASYLUM: 'Asylum', BUNKER: 'Bunker', DISTRICT: 'District', EXHIBIT: "Exibit", ICEBOUND: 'Icebound', TRAININGGROUNDS: "Training Grounds", VASGAR: 'Vasgar',
  BIND: 'Bind', HAVEN: 'Haven', SPLIT: 'Split', ASCENT: 'Ascent',
  CANALS: 'Canals', FAVELAS: 'Favelas', SKYFELL: 'Skyfell', WINDWARD: 'Windward', ICARUS: 'Icarus', VICE: 'Vice', HIGHCASTLE: 'High Castle', FACTORY: 'Factory'
};

export const SUB_TITLES = {
  0:'Huddle in close',
  1:'Immortal Spawn',
  2:'Howdy Doody',
  3:'Esports Playbook',
  4:'Not like those other guys',
};



// WEBPACK FOOTER //
// ./src/app/utils/maps/titleArrays.js